var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67462 5.14085L12.8566 8.3228L5.43198 15.7474H2.25V12.5655L9.67462 5.14085ZM10.7353 4.08019L12.3263 2.4892C12.6192 2.19631 13.094 2.19631 13.3869 2.4892L15.5083 4.61052C15.8012 4.90341 15.8012 5.37829 15.5083 5.67118L13.9172 7.26217L10.7353 4.08019Z",
    fill: "#5E6164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a18ab0ded88148c196c00d67e865f161.svg";
export { ForwardRef as ReactComponent };